<template>
  <div class="login-container">
    <div class="nav">
      <div class="logo"></div>
    </div>
    <div class="login">
      <div class="login-img"></div>
      <div class="login_qw">
        <div class="title-container">
          <div class="title"><p style="text-align: center;margin: 0;padding: 0;">欢迎登录</p>日立电梯聚光计划<br>营销推广知识平台</div>
        </div>
        <div id="login_id"></div>
      </div>
<!--      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">-->
<!--        <div class="title-container">-->
<!--          <div class="title"><p style="text-align: center;margin: 0;padding: 0;">欢迎登录</p>日立电梯聚光计划<br>营销资料管理平台</div>-->
<!--        </div>-->
<!--        &lt;!&ndash;用户名&ndash;&gt;-->
<!--        <el-form-item prop="username">-->
<!--        <span class="svg-container">-->
<!--          <i class="el-icon-user"></i>-->
<!--        </span>-->
<!--          <el-input-->
<!--            ref="username"-->
<!--            v-model="loginForm.username"-->
<!--            placeholder="请输入账号"-->
<!--            name="username"-->
<!--            type="text"-->
<!--            tabindex="1"-->
<!--            auto-complete="on"-->
<!--          />-->
<!--        </el-form-item>-->
<!--        &lt;!&ndash;密码框&ndash;&gt;-->
<!--        <el-form-item prop="password">-->
<!--        <span class="svg-container">-->
<!--          <i class="el-icon-lock"></i>-->
<!--        </span>-->
<!--          <el-input-->
<!--            ref="password"-->
<!--            v-model="loginForm.password"-->
<!--            type="password"-->
<!--            placeholder="请输入密码"-->
<!--            name="password"-->
<!--            tabindex="2"-->
<!--            auto-complete="on"-->
<!--            @keyup.enter.native="handleLogin"-->
<!--          />-->
<!--        </el-form-item>-->
<!--        &lt;!&ndash;登录按钮&ndash;&gt;-->
<!--        <el-button class="but" style="width:378px;height: 50px;font-size: 16px" @click.native.prevent="handleLogin">登录</el-button>-->
<!--        <div class="cma" @click="getQwLogin">扫码登录</div>-->
<!--      </el-form>-->
    </div>
    <div class="login-text">日立电梯 （中国） 有限公司<span style="margin-left: 2px">&nbsp;&nbsp;©&nbsp;Hitachi,&nbsp; Ltd. 1994,&nbsp; 2022.&nbsp; All&nbsp; rights&nbsp;  reserved.</span></div>
  </div>
</template>

<script>
import {getToken, removeToken} from "../../utils/auth";
export default {
  name: 'Login',
  data() {
    return {

    }
  },
  mounted() {
    this.getQwLogin()
  },
  methods: {
    getQwLogin() {
      console.log(localStorage.getItem('UserAdmin'))
      const key = location.hash.split("key=")[1]
      if(key === 'rl'){
        // https://rl.mxmaker.com/web/#/login?key=rl
        // 退出登录的乐享回调进去
        localStorage.removeItem('code')
        localStorage.removeItem('lxState')
        localStorage.removeItem('UserAdmin')
        //重定向
        const hrefH = window.location.origin +  window.location.pathname
        window.location.href = hrefH + '#/login?state=cms_manage_lx'
        return
      }
      if(localStorage.getItem('UserAdmin')){
        this.$router.push('/')
        return
      }
      var censhu = location.hash.split("state=")[1]
      this.$request.QinwenLogin(censhu).then((res) => {
        const data = res.data
        new WwLogin({
          "id": "login_id",
          "appid": data.appid,
          "agentid": data.agentid,
          "redirect_uri": encodeURIComponent(data.redirect_uri),
          "state": data.state,
          "href":"data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE5MHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAxOTBweDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZSAgIWltcG9ydGFudH0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30g"
        })
      }).catch((error)=>{
        console.log(error)
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* 修复input 背景不协调 和光标变色 */

@supports (-webkit-mask: none) and (not (cater-color: black)) {
  .login-container .el-input input {
    color: black;
  }
}
.cma{
  line-height: 40px;
  color: darkgrey;
  margin-right: 320px;
  cursor : pointer;
}
/* reset element-ui css */
.login-container {
  background: url('~@/assets/imgs/image_bg@2x.png') no-repeat center
    center / 100% 100%;
  min-height: 100vh;
  ::v-deep .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: black;
      height: 47px;
      caret-color: black;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px white inset !important;
        -webkit-text-fill-color: black !important;
      }
    }
  }

  ::v-deep .el-form-item {
    border-radius: 5px;
    color: #454545;
    height: 48px;
    width: 378px;
  }
  ::v-deep .el-form-item__error{
    padding-top: 1px !important;
    font-size: 12px !important;
  }
}
::v-deep .el-form-item__content{
  margin-top: 38px;
  background-color: #F9F6F6;
  line-height: 0px !important;
  border: none !important;
}
::v-deep .el-icon-user{
  font-size: 20px !important;
}
::v-deep .el-icon-lock{
  font-size: 20px !important;
}
.but{
  background: linear-gradient(to left, #E60027 0%, #FF4867  100%);
  color: white;
  margin-top: 40px;
}
.login .svg-container{
  margin-left: 17px;
}
</style>

<style lang="less" scoped>
.login-img{
  width: 482px;
  height: 470px;
  background: url('~@/assets/imgs/background_login@2x.png') no-repeat center
  center / 482px auto;
}
.login-text{
  //text-align: center;
  margin-left: 717px;
  margin-top: 66px;
  font-size: 14px;
  color: rgba(0,0,0,0.4500) ;
}
.nav{
  height: 72px;
  width: 100%;
  background-color: white;
  align-items: center;
  display: flex;
  & > .logo {
    margin-left: 176px;
    width:117px;
    height: 42px;
    background: url('~@/assets/imgs/menu_logo@2x.png') no-repeat center
    center / 117px auto;
  }
}
.login_qw{
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  width: 506px;
  max-width: 100%;
  overflow: hidden;
  height:470px ;
  background-color: white;
}
.login{
  display: flex;
  width: 100%;
  overflow: hidden;
  justify-content: center;
  margin-top: 200px;
  .login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    //justify-content: center;
    width: 506px;
    max-width: 100%;
    overflow: hidden;
    height:470px ;
    background-color: white;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    //padding: 6px 5px 6px 15px;
    color: rgba(0, 0, 0, 0.4);
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    margin-top: 59px;
    .title {
      font-size: 28px;
      font-weight: bold;
      //margin-top: 59px;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    user-select: none;
  }
}
.login-container ::v-deep .el-input input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #f9f6f6 inset !important;
  -webkit-text-fill-color: black !important;
}
</style>
